import React from 'react';

export const props = {
  error: null,
  onError: () => {},
};

const Context = React.createContext(props);

export default Context;

export const withErrorMessage = Compoment => props => {
  return <Context.Consumer>
    {(context) => <Compoment {...props} {...context} />}
  </Context.Consumer>
}